import $ from 'jquery';
import React, { useState } from 'react';
import Cookies from 'js-cookie';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import ReactGA from 'react-ga';
import {
  getUrlParameter,
  setCookie,
  getCookie,
  deleteCookie
} from '../../utils';
// eslint-disable-next-line import/named
import { signUpPageView } from '../../firebase/FirebaseRemoteConfigs';

let refCode = getUrlParameter('ref');
let refCodeFromCookie = getCookie('ref');
if (!refCode && refCodeFromCookie) {
  refCode = refCodeFromCookie;
} else if (refCode && !refCodeFromCookie) {
  setCookie('ref', refCode);
}

const useStyles = makeStyles(theme => ({
  paper: {
    margin: theme.spacing(1, 4, 8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    width: theme.spacing(10),
    height: theme.spacing(10),
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.down('md')]: {
      width: `${theme.spacing(4)} !important`,
      height: `${theme.spacing(4)} !important`
    },
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(8),
      height: theme.spacing(8)
    }
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 1),
    padding: theme.spacing(1, 0),
    fontSize: '22px',
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(0.5)
    },
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(3, 0, 1),
      padding: theme.spacing(1, 0)
    }
  },
  progressBar: {
    margin: 'auto',
    position: 'absolute',
    top: '50%'
  },
  formControl: {
    padding: '8px'
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0
  },
  title: {
    whiteSpace: 'pre-line',
    fontWeight: 'bold',
    margin: theme.spacing(1, 0),
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      width: '100%'
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '2.125rem'
    }
  },
  titleSub: {
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      marginTop: -5
    }
  },
  socialGrid: {
    margin: theme.spacing(1)
  },
  socLog: {
    marginTop: 15,
    [theme.breakpoints.down('md')]: {
      marginTop: '5px !important'
    }
  },
  signInButton: {
    cursor: 'pointer',
    paddingLeft: '0px',
    color: '#3f9673',
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'underline'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      marginTop: -3
    }
  },
  signInTypog: {
    [theme.breakpoints.down('md')]: {
      fontSize: '16px'
    }
  },
  socialsInfo: {
    margin: '10px auto',
    textAlign: 'center',
    color: '#48484a',
    padding: theme.spacing(0, 10),
    fontSize: '1.1em',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 8)
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 0),
      fontSize: '1.1em'
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 0),
      fontSize: '1em'
    },
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(0, 0)
    }
  },
  socialSubmit: {
    width: '100%',
    fontSize: 14,
    padding: theme.spacing(1.3, 3),
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: 2,
    border: '1px solid transparent',
    boxShadow:
      'rgb(0 0 0 / 24%) 0px 2px 2px 0px, rgb(0 0 0 / 24%) 0px 0px 1px 0px',
    textTransform: 'none',
    '&:hover': {
      color: 'rgba(0, 0, 0, 0.54)',
      backgroundColor: 'rgb(255, 255, 255)'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  facebookSubmit: {
    backgroundColor: '#1877f2',
    color: '#ffffff',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: '#1877f2'
    }
  },
  sizeAvatar: {
    height: theme.spacing(2.5),
    width: theme.spacing(2.5)
  },
  inputFileds: {
    [theme.breakpoints.down('md')]: {
      '&>div>input': {
        padding: '12px 14px !important',
        color: 'green'
      }
    },
    [theme.breakpoints.down('sm')]: {
      '&>div>input': {
        padding: '18.5px 14px'
      }
    }
  }
}));

export default function Signup(props) {
  const { goToSignIn } = props;
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [verificationType, setVerificationType] = useState(null);

  function handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    setLoading(true);

    $.ajax({
      url: '/user_account/registration/',
      data: formData,
      method: 'POST',
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      processData: false,
      contentType: false,
      success() {
        ReactGA.event({
          category: 'User',
          action: 'SignUp',
          label: "Pro"
        });
        signUpPageView();
        window.location = "/analysis?action=registration";
        deleteCookie('ref');
      },
      error(xhr) {
        let error = {};
        if (xhr.readyState === 4) {
          error = JSON.parse(xhr.responseText);
        } else if (xhr.readyState === 0) {
          error = { common_error: 'Connection error.' };
        } else {
          error = { common_error: 'Something went wrong.' };
        }
        setErrors(error);
        setLoading(false);
      }
    });
  }

  if (loading)
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress className={classes.progressBar} />
      </div>
    );

  return (
    <div className={classes.paper}>
      <Avatar
        alt="chessify logo"
        variant="rounded"
        src={
          navigator.userAgent.toLowerCase().indexOf('safari') !== -1 &&
            navigator.userAgent.toLowerCase().indexOf('chrome') <= -1
            ? '/dg_static/website/images/chessify_icon.jpg'
            : '/dg_static/website/images/chessify_icon.webp'
        }
        className={classes.avatar}
      />
      <Typography
        component="h1"
        variant="h4"
        align="center"
        className={classes.title}
      >
        Train like a Pro with the most powerful cloud engines
      </Typography>
      <Typography omponent="h1" variant="h5" className={classes.titleSub}>
        Already a user?{' '}
        <Button className={classes.signInButton} onClick={goToSignIn}>
          <Typography
            component="h1"
            variant="h5"
            className={classes.signInTypog}
          >
            Sign in
          </Typography>
        </Button>
      </Typography>
      <form
        className={classes.form}
        noValidate
        onSubmit={handleSubmit}
        method="POST"
        encType="multipart/form-data"
      >
        <input
          type="hidden"
          id="referralCode"
          name="referralCode"
          value={refCode}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              error={Boolean(errors.email)}
              helperText={errors.email}
              className={classes.inputFileds}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="username"
              name="username"
              label="Username"
              type="text"
              inputProps={{ maxLength: 25 }}
              error={Boolean(errors.username)}
              helperText={errors.username}
              className={classes.inputFileds}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="password1"
              name="password1"
              label="Password"
              type="password"
              autoComplete="current-password"
              error={
                Boolean(errors.password1) || Boolean(errors.non_field_errors)
              }
              helperText={errors.password1}
              className={classes.inputFileds}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="password2"
              name="password2"
              label="Confirm Password"
              type="password"
              error={
                Boolean(errors.password2) || Boolean(errors.non_field_errors)
              }
              helperText={errors.password2}
              className={classes.inputFileds}
            />
          </Grid>
          <Grid item md={12}>
            <Typography variant="p">
              Make sure your password isn&apos;t entirely numeric, has the minimum length of 8, isn&apos;t similar to your username, and isn&apos;t <a href="https://en.wikipedia.org/wiki/Wikipedia:10,000_most_common_passwords" target="_blank" rel="noreferrer noopener" style={{ color: "#358c65", textDecoration: "none" }}>common</a>.
            </Typography>
          </Grid>
        </Grid>
        <Typography color="error">
          {errors.non_field_errors
            ? errors.non_field_errors
            : errors.common_error}
        </Typography>
        <Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign Up
          </Button>
        </Grid>
        <div className={classes.socialsInfo}>
          <Typography variant="body">
            Sign up with your social media account or email address
          </Typography>
        </div>
        <Grid
          container
          spacing={1}
          alignItems="center"
          className={classes.socLog}
        >
          <Grid item xs={12} md={6}>
            <Button
              startIcon={
                <Avatar
                  alt="google"
                  variant="rounded"
                  className={classes.sizeAvatar}
                  src="/dg_static/website/images/google.png"
                />
              }
              type="submit"
              variant="contained"
              className={classes.socialSubmit}
              href="/accounts/google/login/?process=login"
            >
              <span style={{ marginRight: 17 }}>Continue with Google</span>
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              startIcon={
                <Avatar
                  alt="facebook"
                  variant="rounded"
                  className={classes.sizeAvatar}
                  src="/dg_static/website/images/reverse_fb_logo.png"
                />
              }
              type="submit"
              variant="contained"
              className={`${classes.socialSubmit} ${classes.facebookSubmit}`}
              href="/accounts/facebook/login/?process=login"
            >
              Continue with Facebook
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
